export const TRANSLATIONS_NAMESPACE = 'jbp-global-partner-administration'

export const TRANSLATION_KEYS = {
  widgetTitle: `${TRANSLATIONS_NAMESPACE}--widget-title`,
  globalPartnerTypeButtonPrefix: TRANSLATIONS_NAMESPACE,
  globalPartnerSearchText: `${TRANSLATIONS_NAMESPACE}--global-partner-search-text`,
  globalPartnersTableHeader: `${TRANSLATIONS_NAMESPACE}--global-partners-table-header`,
  addNewGlobalPartner: `${TRANSLATIONS_NAMESPACE}--add-new-global-partner`,
  globalPartnerTableFillter: `${TRANSLATIONS_NAMESPACE}--global-partner-table-filter`,

  tableColumns: {
    globalPartnerName: `${TRANSLATIONS_NAMESPACE}--global-partner-name`,
    globalPartnerGeo: `${TRANSLATIONS_NAMESPACE}--global-partner-geo`,
    globalPartnerData: `${TRANSLATIONS_NAMESPACE}--global-partner-data`,
    globalPartnerDataContent: `${TRANSLATIONS_NAMESPACE}--global-partner-data-content`,
    isPlanRequired: `${TRANSLATIONS_NAMESPACE}--global-partner-data-is-plan-required`,
    isActualsSumUp: `${TRANSLATIONS_NAMESPACE}--global-partner-data-is-actuals-sum-up`,
    globalPartnerPrevYear: `${TRANSLATIONS_NAMESPACE}--global-partner-prev-year`,
    globalPartnerPrevYearNet: `${TRANSLATIONS_NAMESPACE}--global-partner-prev-year-net`,
    globalPartnerCurrYear: `${TRANSLATIONS_NAMESPACE}--global-partner-curr-year`,
    globalPartnerCurrYearNet: `${TRANSLATIONS_NAMESPACE}--global-partner-curr-year-net`,
    globalPartnerFinAim: `${TRANSLATIONS_NAMESPACE}--global-partner-fin-aim`,
    globalPartnerFinAimNet: `${TRANSLATIONS_NAMESPACE}--global-partner-fin-aim-net`,
    globalTotalCompleted: `${TRANSLATIONS_NAMESPACE}--global-fully-total-completed`,
    globalFullyAcknowledged: `${TRANSLATIONS_NAMESPACE}--global-fully-fully-acknowledged`,
    globalPbm: `${TRANSLATIONS_NAMESPACE}--global-pbm`,
    globalFullyCompleted: `${TRANSLATIONS_NAMESPACE}--global-fully-completed`,
    globalFullyCompletedCount: `${TRANSLATIONS_NAMESPACE}--global-fully-completed-count`,
    globalFullyAcknowledgedCount: `${TRANSLATIONS_NAMESPACE}--global-fully-acknowledged-count`,
    globalPartnersCount: `${TRANSLATIONS_NAMESPACE}--global-partners-count`,
    totalPartnerFullyCompleted: `${TRANSLATIONS_NAMESPACE}--total-fully-completed`,
    globalPartnerActuals: `${TRANSLATIONS_NAMESPACE}--global-partner-actuals`,
    globalPartnerActualsNet: `${TRANSLATIONS_NAMESPACE}--global-partner-actuals-net`,
    globalPartnerTargets: `${TRANSLATIONS_NAMESPACE}--global-partner-targets`,
    globalPartnerTargetsNet: `${TRANSLATIONS_NAMESPACE}--global-partner-targets-net`,
    globalPartnerDiff: `${TRANSLATIONS_NAMESPACE}--global-partner-difference-between-act-and-targets`,
    globalPartnerDiffPercent: `${TRANSLATIONS_NAMESPACE}--global-partner-difference-between-act-and-targets-percent`,
  },

  globalPartnerExpanded: {
    completenessChart: {
      chartTitle: `${TRANSLATIONS_NAMESPACE}--completeness-chart-title`,
      fullyAcknowledged: `${TRANSLATIONS_NAMESPACE}--fully-acknowledged`,
      equals100Percent: `${TRANSLATIONS_NAMESPACE}--equals-100-percent`,
      lessThen100Percent: `${TRANSLATIONS_NAMESPACE}--less-then-100-percent`,
      lessThen50Percent: `${TRANSLATIONS_NAMESPACE}--less-then-50-percent`,
    },
    financialsChart: {
      chartTitle: `${TRANSLATIONS_NAMESPACE}--financials-chart-title`,
      export: `${TRANSLATIONS_NAMESPACE}--financials-chart-export`,
    },
    buttonsControls: {
      openP360Plan: `${TRANSLATIONS_NAMESPACE}--open-p360-plan`,
      openPartnerDetails: `${TRANSLATIONS_NAMESPACE}--open-partner-details`,
    },
  },

  globalPartnerDetails: {
    updateTitle: `${TRANSLATIONS_NAMESPACE}--global-partner-details--update-title`,
    createTitle: `${TRANSLATIONS_NAMESPACE}--global-partner-details--create-title`,

    filters: {
      geoMapping: `${TRANSLATIONS_NAMESPACE}--global-partner-details--geo-mapping-filter`,
      productTree: `${TRANSLATIONS_NAMESPACE}--global-partner-details--product-tree-filter`,

      resetButton: `${TRANSLATIONS_NAMESPACE}--global-partner-details--reset-button`,
    },

    entityManagement: {
      market: `${TRANSLATIONS_NAMESPACE}--entity-management-market`,
      partnerName: `${TRANSLATIONS_NAMESPACE}--entity-management-partner-name`,
      pid: `${TRANSLATIONS_NAMESPACE}--entity-management-pid`,
      pbm: `${TRANSLATIONS_NAMESPACE}--entity-management-pbm`,
      dbm: `${TRANSLATIONS_NAMESPACE}--entity-management-dbm`,
      manager: `${TRANSLATIONS_NAMESPACE}--entity-management-manager`,
      country: `${TRANSLATIONS_NAMESPACE}--entity-management-country`,
      specs: `${TRANSLATIONS_NAMESPACE}--entity-management-specs`,
      partnerFlag: `${TRANSLATIONS_NAMESPACE}--entity-management-flag`,
      requiredPlan: `${TRANSLATIONS_NAMESPACE}--entity-management-required-plan`,
      sumUpActuals: `${TRANSLATIONS_NAMESPACE}--entity-management-sum-up-actuals`,
      requiredPlanSwitcher: `${TRANSLATIONS_NAMESPACE}--entity-management-required-plan-switcher`,
      save: `${TRANSLATIONS_NAMESPACE}--entity-management-save`,
    },
    p360LinkWrapper: `${TRANSLATIONS_NAMESPACE} -- global-partner-details--p360-link-wrapper`,
    contentTypeButtonsPrefix: `${TRANSLATIONS_NAMESPACE}--global-partner-details`,
    totalPartners: `${TRANSLATIONS_NAMESPACE}--global-partner-details--total-count-title`,
    hqPartnerIdWarning: `${TRANSLATIONS_NAMESPACE}--global-partner-details--hq-partner-id-warning`,
    addMoreButton: `${TRANSLATIONS_NAMESPACE}--global-partner-details--add-more-button`,
    openPasteFromClipboard: `${TRANSLATIONS_NAMESPACE}--global-partner-details--open-paste-from-clipboard`,
  },

  pasteFromClipboard: {
    title: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-title`,
    apply: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-apply`,
    cancel: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-cancel`,
    clipboardPayloadCount: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-payload-count`,
    clipboardResponseCount: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-response-count`,
    clipboardUnmatched: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-unmatched`,
    wantSave: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-want-save`,
    resultApply: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-result-apply`,
    resultCancel: `${TRANSLATIONS_NAMESPACE}--paste-from-clipboard-result-cancel`,
  },
  addPartnerTable: {
    filters: {
      partnerId: `${TRANSLATIONS_NAMESPACE}--add-partner-table--partner-id`,
      partnerName: `${TRANSLATIONS_NAMESPACE}--add-partner-table--partner-name`,
      refresh: `${TRANSLATIONS_NAMESPACE}--add-partner-table--refresh-button`,
      reset: `${TRANSLATIONS_NAMESPACE}--add-partner-table--reset-button`,
    },
  },

  globalPartnerForm: {
    header: `${TRANSLATIONS_NAMESPACE}--form--header`,
    tabs: {
      basicInfo: `${TRANSLATIONS_NAMESPACE}--form--basic-info`,
      partnerList: `${TRANSLATIONS_NAMESPACE}--form--partner-list`,
    },
    formFields: {
      globalPartnerName: `${TRANSLATIONS_NAMESPACE}--form--fields--global-partner-name}`,
      globalPbm: `${TRANSLATIONS_NAMESPACE}--form--field--pbm`,
      globalDbm: `${TRANSLATIONS_NAMESPACE}--form--field--dbm`,
      globalManager: `${TRANSLATIONS_NAMESPACE}--form--field--manager`,
      globalPartnerRtm: `${TRANSLATIONS_NAMESPACE}--form--field--rtm`,
      isIts: `${TRANSLATIONS_NAMESPACE}--form--field--isits`,
      isReflectOnDashboards: `${TRANSLATIONS_NAMESPACE}--form--field--reflect-on-dashboards`,
      globalPartnerExecutiveSummary: `${TRANSLATIONS_NAMESPACE}--form--field--executive-summary`,
      offerings: `${TRANSLATIONS_NAMESPACE}--form--field--offerings`,
      offeringsRequired: `${TRANSLATIONS_NAMESPACE}--form--field--offerings-required`,
    },
  },
}
